import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { GifLoader } from '../website/GifLoader';

interface BrandGenerationLoaderProps {
  isVisible: boolean;
}

export function BrandGenerationLoader({ isVisible }: BrandGenerationLoaderProps) {
  const { t } = useTranslation();
  const [currentStep, setCurrentStep] = useState<string>('');
  const [stepIndex, setStepIndex] = useState(0);

  const generationSteps = [
    { message: t('brands.generation.steps.analyzing', "Analyzing brand information and target markets..."), duration: 2500 },
    { message: t('brands.generation.steps.identifying', "Identifying brand values and unique selling points..."), duration: 2500 },
    { message: t('brands.generation.steps.exploring', "Exploring your brand assets and your brand style..."), duration: 2500 },
    { message: t('brands.generation.steps.creating', "Creating content strategy and recommendations..."), duration: 2500 },
    { message: t('brands.generation.steps.optimizing', "Optimizing social media presence and channel recommendations..."), duration: 2500 },
    { message: t('brands.generation.steps.finalizing', "Finalizing brand strategy profile..."), duration: 2500 },
  ];

  useEffect(() => {
    if (!isVisible) {
      setStepIndex(0);
      setCurrentStep('');
      return;
    }

    // Reset to first step when becoming visible
    setStepIndex(0);
    setCurrentStep(generationSteps[0].message);

    // Set up the step transition
    const intervalId = setInterval(() => {
      setStepIndex((prevIndex) => {
        const nextIndex = prevIndex + 1;
        
        // If we've gone through all steps, keep showing the last one
        if (nextIndex >= generationSteps.length) {
          clearInterval(intervalId);
          return prevIndex;
        }
        
        // Update the current step message
        setCurrentStep(generationSteps[nextIndex].message);
        return nextIndex;
      });
    }, 2500); // Change step every 2.5 seconds

    return () => clearInterval(intervalId);
  }, [isVisible]);

  if (!isVisible) return null;

  return (
    <GifLoader
      title={t('brands.generation.title', "Creating Your Brand Strategy")}
      currentStep={currentStep}
      videoSrc="/Panda Socialness.ai - Casting a spell.mov"
    />
  );
} 